/**
 * DOM-Hilfsfunktionen
 * Zentralisiert show/hide/toggle-Logik und vermeidet direkte classList-Aufrufe
 */

/** Versteckt ein Element via Bootstrap d-none */
export const hide = (el) => el?.classList.add("d-none");

/** Zeigt ein Element an (entfernt d-none) */
export const show = (el) => el?.classList.remove("d-none");

/** Toggled die Sichtbarkeit eines Elements */
export const toggle = (el) => el?.classList.toggle("d-none");

/** Setzt den disabled-State eines Formularelements */
export const setDisabled = (el, state) => { if (el) el.disabled = state; };

/** Versteckt mehrere Elemente auf einmal */
export const hideAll = (...els) => els.forEach(hide);

/** Zeigt mehrere Elemente auf einmal an */
export const showAll = (...els) => els.forEach(show);

/** Zeigt nur das Zielelement und versteckt alle anderen */
export const showOnly = (target, ...others) => {
  hideAll(...others);
  show(target);
};
